import { useRef, useEffect } from 'react';
import { StationCanvas } from '../components/station/StationCanvas';
import { useAgentStates } from '../hooks/useAgentStates';
import { useCinematicCamera } from '../hooks/useCinematicCamera';

/** Headless 1920×1080 view — no HUD, no nav, no cursor.
 *  Designed as the capture source for TikTok showreels. */
export function RecordView() {
  const { states } = useAgentStates();
  const [camera] = useCinematicCamera();
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    document.title = 'Command Deck · Record';
    document.body.style.cursor = 'none';
    return () => {
      document.body.style.cursor = '';
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="crt-overlay"
      style={{
        width: 1920,
        height: 1080,
        background: 'var(--color-deck-bg)',
        margin: '0 auto',
      }}
    >
      <StationCanvas
        agentStates={states}
        camera={{ ...camera, mode: 'record', crt: true, hudVisible: false }}
        onSelectAgent={() => {
          /* no-op in record mode */
        }}
      />
    </div>
  );
}
